import React from 'react';
import { Translate } from 'core/translate';
import { NetLine, Line } from './Lines';
import { PriceWithConditionalNotification } from './Price';
import { useModelInfo } from '../../common/ModelInfoContext';
import Currency from '../../common/intl/Currency';

const EmployeeNetPriceGroup = ({ pricing }) => {
  const { netEmployeePrice, isUnknownPrice, unknownPriceDisplay, normalizedNetPriceDisplay } = pricing;

  return (
    <NetLine
      labelKey="net.employee.price"
      className="math-box-employee-price"
      price={
        <PriceWithConditionalNotification
          isNetPrice
          notificationName="employee-net-price"
          useModal>
          {isUnknownPrice ? (
            unknownPriceDisplay
          ) : (
            normalizedNetPriceDisplay
          )}
        </PriceWithConditionalNotification>
      }
    />
  );
};

const USEmployeeNetPriceGroup = ({ pricing }) => {
  const { netEmployeePrice, isUnknownPrice, unknownPriceDisplay } = pricing;
  let label;
  if (pricing.employeePrice) {
    label = 'net.employee.price';
  }
  if (!pricing.employeePrice) {
    if (pricing.incentives.total || pricing.incentives.value) {
      label = 'net.price.after.offers';
    } else label = 'net.price.summary.v3';
  }

  return (
    <NetLine
      labelKey={label}
      className="math-box-employee-price"
      price={
        <PriceWithConditionalNotification
          isNetPrice
          notificationName="msrp"
          useModal>
          {isUnknownPrice ? (
            unknownPriceDisplay
          ) : (
            <Currency value={netEmployeePrice} />
          )}
        </PriceWithConditionalNotification>
      }
    />
  );
};

const DefaultNetPriceGroup = ({ pricing, config }) => {
  const {
    normalizedNetPriceDisplay,
    isUnknownPrice,
    unknownPriceDisplay,
  } = pricing;
  const evData = config?.summary?.credits?.ev;
  const evProgram = evData?.program;
  const evProgramAmount = evData?.amount?.text;
  const evProgramDisclaimer = evData?.disclaimers;

  return (
    <>
      <NetLine
        label={<Translate value={'net.price'} />}
        price={
          <PriceWithConditionalNotification
            isNetPrice
            notificationName="msrp"
            useModal>
            {isUnknownPrice ? unknownPriceDisplay : normalizedNetPriceDisplay}
          </PriceWithConditionalNotification>
        }
        className={evProgram ? 'hasEvProgram' : ''}
      />

      {evProgram && (
        <Line
          className={'math-box-evprogram'}
          label={evProgram}
          price={
            <PriceWithConditionalNotification
              useModal
              evProgramModal={evProgramDisclaimer}>
              {evProgramAmount}
            </PriceWithConditionalNotification>
          }
        />
      )}
    </>
  );
};

const NetPriceGroup = ({ pricing, config }) => {
  const { isCanada, isFamilyFirstUS } = useModelInfo();

  if (isCanada && pricing.employeePrice) {
    return <EmployeeNetPriceGroup pricing={pricing} />;
  }

  if (isFamilyFirstUS) {
    return <USEmployeeNetPriceGroup pricing={pricing} />;
  }

  return <DefaultNetPriceGroup pricing={pricing} config={config} />;
};

export default NetPriceGroup;
